(() => {
  class HAInteractiveRackStatic {
    constructor(root) {
      this.root = root;
      this.tiles = Array.from(root.querySelectorAll("[data-ha-irack-static-tile]"));

      if (!this.tiles.length) return;

      const defaultActive = parseInt(root.dataset.defaultActive || "1", 10) - 1;
      this.activeIndex = this.clamp(defaultActive, 0, this.tiles.length - 1);

      this.handleResize = this.debounce(() => this.render(), 80);

      this.bindEvents();
      this.render();
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    getTileUrl(tile) {
      return tile.dataset.haIrackStaticUrl || "";
    }

    goToTileUrl(tile) {
      const url = this.getTileUrl(tile);

      if (!url) return;

      window.location.href = url;
    }

    bindEvents() {
      this.tiles.forEach((tile, index) => {
        const trigger = tile.querySelector("[data-ha-irack-static-trigger]");
        if (!trigger) return;

        trigger.addEventListener("click", () => {
          const isActive = index === this.activeIndex;

          /*
            Mobile behavior:
            - Only visible tiles are clickable.
            - Tap inactive visible tile once to bring it forward.
            - Tap active tile again to open its link.
          */
          if (this.isMobile()) {
            const mobileSlot = tile.getAttribute("data-mobile-slot") || "0";
            if (mobileSlot === "0") return;

            if (isActive) {
              this.goToTileUrl(tile);
              return;
            }

            this.activeIndex = index;
            this.render();
            return;
          }

          /*
            Desktop behavior:
            - Click inactive tile once to activate it.
            - Click active tile again to open its link.
          */
          if (isActive) {
            this.goToTileUrl(tile);
            return;
          }

          this.activeIndex = index;
          this.render();
        });
      });

      window.addEventListener("resize", this.handleResize, { passive: true });
    }

    render() {
      const count = this.tiles.length;

      this.tiles.forEach((tile, index) => {
        const isActive = index === this.activeIndex;
        const trigger = tile.querySelector("[data-ha-irack-static-trigger]");
        const hasUrl = Boolean(this.getTileUrl(tile));

        tile.classList.toggle("is-active", isActive);

        if (trigger) {
          trigger.setAttribute("aria-expanded", String(isActive));

          if (isActive && hasUrl) {
            trigger.setAttribute("aria-label", "Open selected image link");
          } else {
            trigger.setAttribute("aria-label", "Activate image");
          }
        }

        const relative = (index - this.activeIndex + count) % count;
        const mobileOrder = relative + 1;
        const mobileSlot = mobileOrder <= 3 ? String(mobileOrder) : "0";

        tile.style.setProperty("--ha-mobile-order", mobileOrder);
        tile.setAttribute("data-mobile-slot", mobileSlot);
      });
    }

    debounce(fn, wait) {
      let timeout;
      return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  const init = () => {
    document.querySelectorAll("[data-ha-irack-static]").forEach((section) => {
      if (!section.__haInteractiveRackStatic) {
        section.__haInteractiveRackStatic = new HAInteractiveRackStatic(section);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();